import { type ReactNode } from "react";
import { Box, Typography, styled } from "~/common/mui";

const ParamsGridRoot = styled(Box)({
  display: "flex",
  width: "100%",
});

const ParamsGridColumn = styled(Box, {
  shouldForwardProp: (prop) => prop !== "$noFlex",
})<{ $noFlex?: boolean }>(({ $noFlex }) => ({
  display: "flex",
  flexDirection: "column",
  flexWrap: "wrap",
  ...(!$noFlex && { flex: 1 }),
}));

const ParamCompValue = styled(Typography)({
  marginTop: 0.5,
  color: "text.primary",
  wordBreak: "break-all",
  alignSelf: "flex-start",
});

export const ParamsGrid = ({ params, noColumnFlex }: ParamsGridProps) => {
  return (
    <ParamsGridRoot>
      {params.map((column, index) => (
        <ParamsGridColumn $noFlex={noColumnFlex} key={`column-${index}`}>
          {column.map((row, i) => (
            <ParamComponent label={row.label} value={row.value} key={`param-${i}`} />
          ))}
        </ParamsGridColumn>
      ))}
    </ParamsGridRoot>
  );
};

export const ParamComponent = (props: { label: ReactNode; value: ReactNode | ReactNode[] }) => (
  <Box sx={{ display: "flex", flexDirection: "column", pt: "8px", pr: "32px" }}>
    <Typography variant="bodySmall" sx={{ color: "text.label" }}>
      {props.label}
    </Typography>
    {Array.isArray(props.value) &&
      props.value.map((val) => <ParamCompValue variant="bodyMedium">{val}</ParamCompValue>)}
    {!Array.isArray(props.value) && <ParamCompValue variant="bodyMedium">{props.value}</ParamCompValue>}
  </Box>
);

export interface ParamsGridProps {
  params: ParamOptions[][];
  noColumnFlex?: boolean;
}

interface ParamOptions {
  label: ReactNode;
  value: ReactNode;
}
